import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { getProviderLogo } from '../../../helpers';
import { screens } from '../../../styles/constants';
import { DynamicSearchPageInformation } from '../types';
import messages from './messages';

const Container = styled.div`
  ${tw`bg-white p-big rounded-30 flex flex-col`}
  gap: var(--size-medium);

  @media (min-width: ${screens.md}) {
    padding: calc(2 * var(--size-medium2))
      calc(var(--size-medium2) + var(--size-huge2));
  }
`;

const ProviderLogoContainer = styled.div`
  ${tw`py-medium2 flex flex-wrap justify-center items-center`}
  gap: var(--size-medium);
`;

type TripProvidersProps = {
  providers: DynamicSearchPageInformation['companies'];
};

const TripProviders = (props: TripProvidersProps) => {
  return (
    <Container>
      <ProviderLogoContainer>
        {props.providers.slice(0, 4).map((provider, index) => (
          <ProviderLogo key={index} provider={provider} />
        ))}
      </ProviderLogoContainer>

      <ProviderList {...props} />
    </Container>
  );
};

const Logo = styled.img`
  max-width: 202px;
  max-height: 40px;
  height: 100%;
  width: 100%;
`;

type ProviderLogoProps = {
  provider: TripProvidersProps['providers'][0];
};

const ProviderLogo = (props: ProviderLogoProps) => {
  const { provider } = props;
  const logo = getProviderLogo(provider.fullname);

  if (!logo) {
    return null;
  }

  return <Logo alt={logo.alt} src={logo.src} />;
};

const ProviderListContainer = styled.div`
  ${tw`text-p-large leading-p-large flex flex-col text-center`}
`;

const ProviderListHeader = styled.span`
  ${tw`font-kyrial`}
`;

const ProviderList = (props: TripProvidersProps) => {
  return (
    <ProviderListContainer>
      <ProviderListHeader>
        <FormattedMessage {...messages.carriers} />
      </ProviderListHeader>

      <span>
        {props.providers.map((company) => company.fullname).join(', ')}.
      </span>
    </ProviderListContainer>
  );
};

export default TripProviders;
